

export const groupAccessStatusList = [
    { title: 'Active', status: 'active' }, 
    { title: 'Inactive', status: 'inactive' },
    { title: 'Suspended', status: 'suspended' }, 
    { title: 'Blocked', status: 'blocked' }
];